import React from 'react'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { InsightContentSettingType } from 'components/insightContent/types'
import { CountTypeStrings } from 'enums/CountType'
import { getPercentOfTotal } from 'components/insightContent/utils/utils'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { useTrendingTotalMeasureCount } from 'components/insightContent/hooks'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useRowSparklineData from 'components/widget/TrendingWidgets/share/InsightModal/hooks/useRowSparklineData'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import { MeasureType } from 'enums'
import RunSearchEffect from './RunSearchEffect'

const TrendingSingleMeasure = ({
  detailSetting,
  countType,
  widgetId,
  renderTitleContent
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  widgetId?: number
  renderTitleContent?: () => React.ReactNode
}) => {
  const insightContent = useInsightContentData(InsightContentType.TRENDING_SINGLE_MEASURE)
  const total = useTrendingTotalMeasureCount()
  const sparklineData = useRowSparklineData(widgetId!, detailSetting?.selectionName)

  const percent = getPercentOfTotal(
    insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0],
    total
  )

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting} countType={countType}>
        <SparklineOverview
          sparklineData={sparklineData || []}
          measureType={MeasureType.POSTS}
          title={renderTitleContent && renderTitleContent()}
          displayTitleTooltip={detailSetting.displayTitleTooltip}
          count={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          percent={percent}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}
export default TrendingSingleMeasure
